import { pairwise, distinctUntilKeyChanged, filter, map, startWith } from 'rxjs';
import { store, store$ } from '@redux/store';
import { LocationType, searchParametersActions } from 'features/searchResultsFacets';
import { selectAutoSelectTabContext } from '../redux/selectors';

const hasLocationChanged = (previous, current) =>
  (previous?.location ?? null) !== (current?.location ?? null);

const isRectangularArea = (location) => location?.locationType === LocationType.RectangularArea.toString();

const hasAutoSelectTarget = (context) => Boolean(context.productResultType);

const hasNoAppliedFilters = (context) => !context.hasAppliedFilters;

const isNoResults = (context) => (context?.counts?.listingCount ?? 0) === 0;

const hasHomesResult = (context) => (context?.counts?.homesCount ?? 0) > 0;

const onAutoSelectTab$ = store$.pipe(
  map(selectAutoSelectTabContext),
  distinctUntilKeyChanged('counts'),
  startWith(null), // null seeds pairwise so the very first real emission can be evaluated
  pairwise(),
  filter(([previous, current]) => hasLocationChanged(previous, current)),
  map(([, current]) => current),
  filter((current) => !isRectangularArea(current.location)),
  filter(hasAutoSelectTarget),
  filter(hasNoAppliedFilters),
  filter(isNoResults),
  filter(hasHomesResult),
  map((current) => current.productResultType)
);

onAutoSelectTab$.subscribe((targetResultType) => {
  store.dispatch(searchParametersActions.fetchResultsType(targetResultType));
});
